import { BUSINESS } from "@/lib/beef";

export const Footer = () => (
  <footer className="bg-forest text-cream border-t border-cream/10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
      <div>
        <img src="/images/logo-mark.png" alt="Waters & Field logo" className="w-12 h-12 object-contain bg-cream rounded-full p-1 mb-3" />
        <p className="font-display text-2xl font-semibold">{BUSINESS.name}</p>
        <p className="text-cream/60 text-base mt-2">Local Florida beef. Grass fed, natural grain finished. Sold whole, half, and quarter.</p>
      </div>
      <div className="text-base text-cream/70 space-y-1.5">
        <p>{BUSINESS.phone} &middot; {BUSINESS.email}</p>
        <p className="text-cream/40 pt-2">&copy; {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
        <a
          href="/admin"
          data-testid="manager-login-link"
          className="inline-block mt-4 rounded-full border border-cream/30 text-cream font-semibold px-6 py-3 text-sm hover:bg-cream/10 transition-[background-color] duration-200"
        >
          Farm Manager Login
        </a>
      </div>
    </div>
  </footer>
);
